/**
 * Created by lapcho on 24.02.17..
 */
/**
 * Created by lapcho on 06.02.17..
 */
export default class {
    constructor($http,toastr,$q,Config) {
        'ngInject';
        this.$http = $http;
        this.toastr = toastr;
        this.$q = $q;
        this.Config = Config;
    }

    $onInit() {
    }

   sendEmailWithCollections(address, collection_ids) {

       var data = {
           collections: collection_ids,
           email: address
       }
       return this.$http({
           url: this.Config.API + '/contentbank-collection/pdf/email',
           method: 'POST',
           data: data
       }).then((response) => {
          this.toastr.success('Collections PDF sent to email');
       }).catch((status) => {
           this.toastr.error('Error occured while sending email, please try again');
       })

   };

}



// WEBPACK FOOTER //
// ./client/app/services/email.js